module.exports = __webpack_public_path__ + "img/noData@2x.f419e198.png";